export type CmsBackgroundColor = "white" | "color";
export type UiBackgroundColor = "white" | "lightBlue" | "gray";

const UI_BACKGROUND_HEX: Record<UiBackgroundColor, string> = {
  white: "#ffffff",
  lightBlue: "#f1f8ff",
  gray: "#f5f5f5",
};

export function resolveCmsBackgroundColor(
  backgroundColor: CmsBackgroundColor | undefined,
  isEmployerSite: boolean,
  missing: UiBackgroundColor | undefined = undefined
): UiBackgroundColor | undefined {
  if (backgroundColor === "white") return "white";
  if (backgroundColor === "color") {
    return isEmployerSite ? "gray" : "lightBlue";
  }
  return missing;
}

/** Jobs pages: CMS "color" is Light blue for header + list, never gray. */
export function resolveJobsPageBackgroundColor(
  backgroundColor?: CmsBackgroundColor
): UiBackgroundColor | undefined {
  if (backgroundColor === "white") return "white";
  if (backgroundColor === "color") return "lightBlue";
  return undefined;
}

export function uiBackgroundColorHex(
  color: UiBackgroundColor | undefined,
  fallback: string
): string {
  return color ? UI_BACKGROUND_HEX[color] : fallback;
}
